module.exports = __webpack_public_path__ + "static/media/evaluation--dark.51e53b9d.png";